import { render, staticRenderFns } from "./TipsCard.vue?vue&type=template&id=6c6200f8&scoped=true"
import script from "./TipsCard.vue?vue&type=script&lang=js"
export * from "./TipsCard.vue?vue&type=script&lang=js"
import style0 from "./TipsCard.vue?vue&type=style&index=0&id=6c6200f8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6200f8",
  null
  
)

export default component.exports